import * as React from "react";
import { Redirect, Route, Switch } from "react-router";
import { ConnectedRouter } from "connected-react-router";
import { Store } from 'redux'
import { Provider } from 'react-redux'
import App from "./components/App";
import { IApplicationState, history } from "./store";

// Common component imports
import HomePage from "./components/home/HomePage";
import Projecten from "./components/rapporten/vaph/Projecten"
import AboutPage from "./components/about/AboutPage";
import Takenlijst from "./components/rapporten/dop/Takenlijst";

// VAPH reports
import VaphAfrekeningRapport from "./components/rapporten/vaph/afrekening"
import VaphAanmeldingenRapport from "./components/rapporten/vaph/AanmeldingenPerPeriode"

// Internal reports imports
import AanmeldingenWachtlijst from "./components/rapporten/internal/AanmeldingenWachtlijstRapport"
import ContactenPerMedewerkerPerMaand from "./components/rapporten/internal/ContactenPerMedewerkerPerMaandRapport"
import ContactenPerMaand from "./components/rapporten/internal/ContactenPerMaandRapport"
import LopendeDossiersRapport from "./components/rapporten/internal/LopendeDossiersRapport"
import GewichtRapport from "./components/rapporten/internal/GewichtRapport"
import ContactenPerMedewerkerPerDagRapport from "./components/rapporten/internal/ContactenPerMedewerkerPerDagRapport"

// DOP reports imports
import Voorrangdossiers from "./components/rapporten/dop/Voorrangdossiers";
import AchttienmaandenMax from "./components/rapporten/dop/AchttienmaandenMax";
import AchttienmaandenProces from "./components/rapporten/dop/AchttienmaandenProces";
import EenmaligContactDop from "./components/rapporten/dop/EenmaligContact";
import DopDuosLopendeClienten from "./components/rapporten/dop/DopDuosLopendeClienten";
import Traject from "./components/rapporten/dop/Traject";
import EersteContact from "./components/rapporten/dop/EersteContact";
import RegistratiesDoorMedewerkers from "./components/rapporten/dop/RegistratiesDoorMedewerkers";
import EvaluatieMedewerker from "./components/rapporten/dop/EvaluatieMedewerker";
import DossiersPerGemeente from "./components/rapporten/dop/DossiersPerGemeente";
import ContactenPerMaandProjecten from "./components/rapporten/dop/ContactenPerMaandProjecten"
import Wachtlijst from "./components/rapporten/dop/Wachtlijst";

// Jaarverslag imports
import JaarrapportAanmeldingAantalPerMaand from "./components/rapporten/jaarverslag/AanmeldingAantalPerMaand"
import AanmeldingAangemeldAfgeslotenZonderContact from "./components/rapporten/jaarverslag/AanmeldingAangemeldAfgeslotenZonderContactReport"
import AanmeldingLeeftijdGeslachtBeperkingActivieteitEnz from "./components/rapporten/jaarverslag/AanmeldingLeeftijdGeslachtBeperkingActivieteitEnz"
import AanmeldingVerwijzer from "./components/rapporten/jaarverslag/AanmeldingVerwijzer"
import ProcesDossierverloop from "./components/rapporten/jaarverslag/ProcesDossierverloop"
import EenmaligContactJaarverslag from "./components/rapporten/jaarverslag/EenmaligContact"
import VroegtijdigeStopzetting from "./components/rapporten/jaarverslag/VroegtijdigeStopzetting"
import ProcesLeeftijdGeslachtBeperkingActivieteitEnz from "./components/rapporten/jaarverslag/ProcesLeeftijdGeslachtBeperkingActivieteitEnz"
import ProcesContactplaats from "./components/rapporten/jaarverslag/ProcesContactplaats"
import OndersteuningsCirkelsInstroomEnUitstroom from "./components/rapporten/jaarverslag/OndersteuningsCirkelsInstroomEnUitstroom"
import OndersteuningsCirkelsUitstroom from "./components/rapporten/jaarverslag/OndersteuningscirkelsUitstroom"
import OndersteuningscirkelsInstroom from "./components/rapporten/jaarverslag/OndersteuningscirkelsInstroom";
import ProcesGedetineerden from "./components/rapporten/jaarverslag/ProcesGedetineerden";
import ProcesBijkomendeUitdaging from "./components/rapporten/jaarverslag/ProcesBijkomendeUitdaging";
import AanmeldingGeenVermoedenBeperking from "./components/rapporten/jaarverslag/AanmeldingGeenVermoedenBeperking";
import AanmeldingOpPvb from "./components/rapporten/jaarverslag/AanmeldingOpPvb";
import AfgeslotenOpPvb from "./components/rapporten/jaarverslag/AfgeslotenOpPvb";
import AfgeslotenGemiddeldeDuurProcesInMaanden from "./components/rapporten/jaarverslag/AfgeslotenGemiddeldeDuurProcesInMaanden";
import RedenVanAfsluitPerClient from "./components/rapporten/jaarverslag/RedenVanAfsluitPerClient";
import RedenVanAfsluit from "./components/rapporten/jaarverslag/RedenVanAfsluit";
import RedenHeraanmeldingPerClient from "./components/rapporten/jaarverslag/RedenHeraanmeldingPerClient";
import RedenHeraanmelding from "./components/rapporten/jaarverslag/RedenHeraanmelding";
import AfgeslotenAardVanHandicap from "./components/rapporten/jaarverslag/AfgeslotenAardVanHandicap";
import AfgeslotenLeeftijdGeslachtBeperkingActivieteitEnz from "./components/rapporten/jaarverslag/AfgeslotenLeeftijdGeslachtBeperkingActivieteitEnz";

// Chart imports
import ContactenPerMaandChart from "./components/rapporten/charts/ContactenPerMaandChart";
import OndersteuningsCirkelsDeltaChart from "./components/rapporten/charts/OndersteuningsCirkelsDeltaChart";
import VerdelingCas from "./components/rapporten/dop/VerdelingCas";
import AfgeslotenOndersteuningscirkelsUitstroomWachtlijst
    from "./components/rapporten/jaarverslag/AfgeslotenOndersteuningscirkelsUitstroomWachtlijst";


import { ThemeProvider } from '@material-ui/core/styles';
import { theme } from './design/theme';
import { databaseUrl, oldDatabaseUrl, oldRapportenUrl, routes } from "./routes";


import MainPageLayout from './design/templates/MainPageLayout';

interface IOwnProps {
    store: Store<IApplicationState>
}

type AllProps = IOwnProps

class MainRouter extends React.Component<AllProps> {
    public render() {


        return (
            <Provider store={this.props.store}>
                <MainPageLayout pages={routes.pages}>
                <ConnectedRouter history={history}><>
                    <Switch>
                    <Route exact path="/" render={() => <Redirect to={`${databaseUrl}/`} />} />

                    <Route path={databaseUrl}>
                        <ThemeProvider theme={theme}>
                            
                                <Switch>
                                    {routes.pages.filter(x => x.component).map((page) => (
                                        <Route 
                                            exact={page.isExact} 
                                            key={page.route ? page.route : page.url} 
                                            path={page.route ? page.route : page.url} 
                                            render={(props) => page.component ? React.createElement(page.component, { ...props, key: props.location.pathname }) : null} />
                                    ))}
                                </Switch>
                        </ThemeProvider>
                    </Route>

                    <Route path={oldRapportenUrl}>
                        <App baseUrl={oldRapportenUrl} databaseUrl={databaseUrl} oldDatabaseUrl={oldDatabaseUrl}>
                            {/* Common routes */}
                            <Route exact path={`${oldRapportenUrl}/`} component={HomePage} />
                            <Route path={`${oldRapportenUrl}/about`} component={AboutPage} />

                            {/* VAPH reports */}
                            <Route path={`${oldRapportenUrl}/vaph/afrekening`} component={VaphAfrekeningRapport} />
                            <Route path={`${oldRapportenUrl}/vaph/aanmeldingen`} component={VaphAanmeldingenRapport} />
                            <Route path={`${oldRapportenUrl}/vaph/projecten`} component={Projecten} />

                            {/* Internal reports */}
                            <Route path={`${oldRapportenUrl}/internal/aanmeldingenWachtlijst`} component={AanmeldingenWachtlijst} />
                            <Route path={`${oldRapportenUrl}/internal/contactenPerMedewerkerPerMaand`} component={ContactenPerMedewerkerPerMaand} />
                            <Route path={`${oldRapportenUrl}/internal/contactenPerMaand`} component={ContactenPerMaand} />
                            <Route path={`${oldRapportenUrl}/internal/lopendeDossiers`} component={LopendeDossiersRapport} />
                            <Route path={`${oldRapportenUrl}/internal/gewicht`} component={GewichtRapport} />
                            <Route path={`${oldRapportenUrl}/internal/contactenPerMedewerkerPerDag`} component={ContactenPerMedewerkerPerDagRapport} />

                            {/* DOP Reports */}
                            <Route path={`${oldRapportenUrl}/dop/voorrangsdossiers`} component={Voorrangdossiers} />
                            <Route path={`${oldRapportenUrl}/dop/achttienmaandenproces`} component={AchttienmaandenProces} />
                            <Route path={`${oldRapportenUrl}/dop/achttienmaandenmax`} component={AchttienmaandenMax} />
                            <Route path={`${oldRapportenUrl}/dop/eenmaligContact`} component={EenmaligContactDop} />
                            <Route path={`${oldRapportenUrl}/dop/DopDuosLopendeClienten`} component={DopDuosLopendeClienten} />
                            <Route path={`${oldRapportenUrl}/dop/takenlijst`} component={Takenlijst} />
                            <Route path={`${oldRapportenUrl}/dop/Traject`} component={Traject} />
                            <Route path={`${oldRapportenUrl}/dop/EersteContact`} component={EersteContact} />
                            <Route path={`${oldRapportenUrl}/dop/RegistratiesDoorMedewerkers`} component={RegistratiesDoorMedewerkers} />
                            <Route path={`${oldRapportenUrl}/dop/EvaluatieMedewerker`} component={EvaluatieMedewerker} />
                            <Route path={`${oldRapportenUrl}/dop/DossiersPerGemeente`} component={DossiersPerGemeente} />
                            <Route path={`${oldRapportenUrl}/dop/ContactenPerMaandProjecten`} component={ContactenPerMaandProjecten} />
                            <Route path={`${oldRapportenUrl}/dop/verdelingcas`} component={VerdelingCas} />
                            <Route path={`${oldRapportenUrl}/dop/wachtlijst`} component={Wachtlijst} />

                            {/* Jaarrapporten */}
                            <Route path={`${oldRapportenUrl}/jaarrapport/AanmeldingAantalPerMaand`} component={JaarrapportAanmeldingAantalPerMaand} />
                            <Route path={`${oldRapportenUrl}/jaarrapport/AanmeldingAangemeldAfgeslotenZonderContact`} component={AanmeldingAangemeldAfgeslotenZonderContact} />
                            <Route path={`${oldRapportenUrl}/jaarrapport/AanmeldingLeeftijdGeslachtBeperkingActivieteitEnz`} component={AanmeldingLeeftijdGeslachtBeperkingActivieteitEnz} />
                            <Route path={`${oldRapportenUrl}/jaarrapport/AanmeldingVerwijzer`} component={AanmeldingVerwijzer} />
                            <Route path={`${oldRapportenUrl}/jaarrapport/AanmeldingGeenVermoedenBeperking`} component={AanmeldingGeenVermoedenBeperking} />
                            <Route path={`${oldRapportenUrl}/jaarrapport/ProcesDossierverloop`} component={ProcesDossierverloop} />
                            <Route path={`${oldRapportenUrl}/jaarrapport/EenmaligContact`} component={EenmaligContactJaarverslag} />
                            <Route path={`${oldRapportenUrl}/jaarrapport/VroegtijdigeStopzetting`} component={VroegtijdigeStopzetting} />
                            <Route path={`${oldRapportenUrl}/jaarrapport/ProcesLeeftijdGeslachtBeperkingActivieteitEnz`} component={ProcesLeeftijdGeslachtBeperkingActivieteitEnz} />
                            <Route path={`${oldRapportenUrl}/jaarrapport/ProcesContactplaats`} component={ProcesContactplaats} />
                            <Route path={`${oldRapportenUrl}/jaarrapport/OndersteuningsCirkelsInstroomEnUitstroom`} component={OndersteuningsCirkelsInstroomEnUitstroom} />
                            <Route path={`${oldRapportenUrl}/jaarrapport/OndersteuningsCirkelsUitstroom`} component={OndersteuningsCirkelsUitstroom} />
                            <Route path={`${oldRapportenUrl}/jaarrapport/OndersteuningscirkelsInstroom`} component={OndersteuningscirkelsInstroom} />
                            <Route path={`${oldRapportenUrl}/jaarrapport/ProcesGedetineerden`} component={ProcesGedetineerden} />
                            <Route path={`${oldRapportenUrl}/jaarrapport/ProcesBijkomendeUitdaging`} component={ProcesBijkomendeUitdaging} />
                            <Route path={`${oldRapportenUrl}/jaarrapport/AanmeldingOpPvb`} component={AanmeldingOpPvb} />
                            <Route path={`${oldRapportenUrl}/jaarrapport/AfgeslotenOpPvb`} component={AfgeslotenOpPvb} />
                            <Route path={`${oldRapportenUrl}/jaarrapport/AfgeslotenGemiddeldeDuurProcesInMaanden`} component={AfgeslotenGemiddeldeDuurProcesInMaanden} />
                            <Route path={`${oldRapportenUrl}/jaarrapport/RedenVanAfsluitPerClient`} component={RedenVanAfsluitPerClient} />
                            <Route path={`${oldRapportenUrl}/jaarrapport/RedenVanAfsluit`} component={RedenVanAfsluit} />
                            <Route path={`${oldRapportenUrl}/jaarrapport/RedenHeraanmeldingPerClient`} component={RedenHeraanmeldingPerClient} />
                            <Route path={`${oldRapportenUrl}/jaarrapport/RedenHeraanmelding`} component={RedenHeraanmelding} />
                            <Route path={`${oldRapportenUrl}/jaarrapport/AfgeslotenAardVanHandicap`} component={AfgeslotenAardVanHandicap} />
                            <Route path={`${oldRapportenUrl}/jaarrapport/AfgeslotenLeeftijdGeslachtBeperkingActivieteitEnz`} component={AfgeslotenLeeftijdGeslachtBeperkingActivieteitEnz} />
                            <Route path={`${oldRapportenUrl}/jaarrapport/AfgeslotenOndersteuningscirkelsWachtrij`} component={AfgeslotenOndersteuningscirkelsUitstroomWachtlijst} />

                            {/* Charts */}
                            <Route path={`${oldRapportenUrl}/charts/ContactenPerMaand`} component={ContactenPerMaandChart} />
                            <Route path={`${oldRapportenUrl}/charts/OndersteuningsCirkelsTrend`} component={OndersteuningsCirkelsDeltaChart} />
                        </App>
                    </Route>
                    </Switch>
                    </></ConnectedRouter>
                    </MainPageLayout>
            </Provider>
        );
    }
}

export default MainRouter;
